/* eslint-disable semi */

class DataFetcher {

  async get(url) {
    return await this.request(url)
  }

  async post(url, data) {
    return await this.request(url, { method: 'POST', body: data })
  }

  async put(url, data) {
    return await this.request(url, { method: 'PUT', body: data })
  }

  async request(url, options = { method: 'GET', body: null }) {
    const response = await fetch(url, {
      method: options.method,
      body: options.body ? JSON.stringify(options.body) : null,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })

    return await response.json()
  }
}

export default DataFetcher
